import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import SVG from 'react-inlinesvg'

import './CardInformationIcon.scss'

function CardInformationIcon({ icon, text, theme, title }) {
  return (
    <div className={`cardInformationIcon type-${theme} d-md-flex`}>
      <div className="cardInformationIcon-icon">{icon && icon.includes('/') && <SVG src={icon} />}</div>
      <div className="cardInformationIcon-content">
        <h3 className="cardInformationIcon-title">{title}</h3>
        <div className="cardInformationIcon-text">{ReactHtmlParser(text)}</div>
      </div>
    </div>
  )
}

CardInformationIcon.propTypes = {
  theme: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'transparent']),
  icon: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
}

export default CardInformationIcon
